<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const props = defineProps({
  area: { type: String, required: true }
})

const { data: livecamData } = await useFetch(`/api/livecam/list`, { query: { area: props.area } })

</script>

<template>
  <section class="livecamList">
    <SectionTitle title="ライブカメラ一覧" />
    <ul class="content">
      <li
        v-for="content in livecamData"
        :key="content.name"
      >
        <LivecamBlock
          :text="content.name"
          :link="content.path"
          :date="content.announced"
          :img="content.img"
        />
      </li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.livecamList {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .content {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, calc((100% - 10px) / 2));
    gap: 10px;
  }
  .button {
    display: flex;
    justify-content: center;
  }
}
@media screen and (min-width: 830px) {
  .livecamList {
    .content {
      grid-template-columns: repeat(4, calc((100% - 30px) / 4));
    }
  }
}
</style>
